import { useState, useEffect } from 'react';

/**
 * Custom hook for parallax scroll effects
 * @param {number} speed - Parallax speed (0.1 = slow, 1 = same as scroll)
 * @param {string} direction - 'up' or 'down'
 * @returns {number} translateY value
 */
const useParallax = (speed = 0.3, direction = 'up') => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const multiplier = direction === 'up' ? -1 : 1;
      setOffset(scrollY * speed * multiplier);
    };

    // Throttle scroll events for performance
    let ticking = false;
    const throttledScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', throttledScroll);
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [speed, direction]);

  return offset;
};

export default useParallax;
